export default __webpack_public_path__ + "static/media/Aula3.7c4007b7.jpeg";